import {
    Icon20Chain,
    Icon20DeleteOutline,
    Icon20DocumentListOutline,
    Icon20DocumentOutline,
    Icon20DocumentStatsOutline,
    Icon20DocumentTextOutline,
    Icon20HistoryBackwardOutline,
    Icon24Linked,
} from '@vkontakte/icons';
import React from 'react';
import { showAllDocumentsIncomingPublic } from 'reactApp/appHelpers/featuresHelpers/features/incomingPublic';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { EDocumentsDomainTreeRootIds, ETreeRootIds } from 'reactApp/ui/TreeComponent/TreeComponent.constants';
import { treeItemsFlatten } from 'reactApp/ui/TreeComponent/TreeComponent.data';
import type { TreeNodeData } from 'reactApp/ui/TreeComponent/TreeNode.types';

export const treeRootAllDocumentsConfig: TreeNodeData[] = [
    treeItemsFlatten[ETreeRootIds.alldocumentsDocument],
    treeItemsFlatten[ETreeRootIds.alldocumentsSpreadsheet],
    treeItemsFlatten[ETreeRootIds.alldocumentsPresentation],
    treeItemsFlatten[ETreeRootIds.alldocumentsPdf],
    treeItemsFlatten[ETreeRootIds.alldocumentsTrashbin],
];
if (showAllDocumentsIncomingPublic) {
    treeRootAllDocumentsConfig.unshift(treeItemsFlatten[ETreeRootIds.alldocumentsIncoming]);
}

interface TreeRootConfigAllDocumentsHandlerOptions {
    showFamily: boolean;
    showVigbo: boolean;
    isVigboLinkedAccount: boolean;
}

export const treeRootConfigAllDocumentsHandler = (options: TreeRootConfigAllDocumentsHandlerOptions): TreeNodeData[] => {
    const { showFamily, showVigbo, isVigboLinkedAccount } = options;

    return [
        {
            ...treeItemsFlatten[ETreeRootIds.home],
            hideIcon: true,
        },
        treeItemsFlatten[ETreeRootIds.domain],
        treeItemsFlatten[ETreeRootIds.gallery],
        treeItemsFlatten[ETreeRootIds.aiGeneration],
        treeItemsFlatten[ETreeRootIds.albums],
        {
            ...treeItemsFlatten[ETreeRootIds.documents],
            divider: !showFamily && !showVigbo,
        },
        ...(showFamily
            ? [
                  {
                      ...treeItemsFlatten[ETreeRootIds.familyFolders],
                      isNewChip: true,
                      divider: !showVigbo,
                  },
              ]
            : []),
        ...(showVigbo
            ? [
                  {
                      ...treeItemsFlatten[ETreeRootIds.vigbo],
                      isNewChip: !isVigboLinkedAccount,
                      divider: true,
                  },
              ]
            : []),
        {
            ...treeItemsFlatten[ETreeRootIds.feed],
            title: 'Недавние',
            icon: <Icon20HistoryBackwardOutline />,
        },
        {
            ...treeItemsFlatten[ETreeRootIds.sharedLinks],
            title: 'Совместные',
            folderCounter: 0,
            icon: <Icon20Chain />,
        },
        treeItemsFlatten[ETreeRootIds.favorites],
        {
            ...treeItemsFlatten[ETreeRootIds.trashbin],
            divider: true,
            folderCounter: 0,
        },
        {
            ...treeItemsFlatten[ETreeRootIds.alldocuments],
            divider: true,
            isBeta: true,
        },
        {
            ...treeItemsFlatten[ETreeRootIds.attaches],
            folderCounter: 0,
        },
    ];
};

const documentsDomainTreeItemsFlatten: Record<EDocumentsDomainTreeRootIds, TreeNodeData> = {
    [EDocumentsDomainTreeRootIds.alldocumentsDomainIncoming]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainIncoming,
        title: 'Доступные мне',
        gaId: 'alldocumentsDomainIncoming',
        storage: EStorageType.incomingPublic,
        icon: <Icon24Linked />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainIncoming,
    },
    [EDocumentsDomainTreeRootIds.alldocumentsDomainDocument]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainDocument,
        title: 'Документы',
        gaId: 'alldocumentsDomainDocument',
        storage: EStorageType.alldocuments,
        icon: <Icon20DocumentTextOutline />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainDocument,
    },
    [EDocumentsDomainTreeRootIds.alldocumentsDomainSpreadsheet]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainSpreadsheet,
        title: 'Таблицы',
        gaId: 'alldocumentsDomainSpreadsheet',
        storage: EStorageType.alldocuments,
        icon: <Icon20DocumentListOutline />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainSpreadsheet,
    },
    [EDocumentsDomainTreeRootIds.alldocumentsDomainPresentation]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainPresentation,
        title: 'Презентации',
        gaId: 'alldocumentsDomainPresentation',
        storage: EStorageType.alldocuments,
        icon: <Icon20DocumentStatsOutline />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainPresentation,
    },
    [EDocumentsDomainTreeRootIds.alldocumentsDomainPdf]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainPdf,
        title: 'PDF',
        gaId: 'alldocumentsDomainPdf',
        storage: EStorageType.alldocuments,
        icon: <Icon20DocumentOutline />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainPdf,
    },
    [EDocumentsDomainTreeRootIds.alldocumentsDomainTrashbin]: {
        id: EDocumentsDomainTreeRootIds.alldocumentsDomainTrashbin,
        title: 'Корзина',
        gaId: 'alldocumentsDomainTrashbin',
        storage: EStorageType.alldocuments,
        icon: <Icon20DeleteOutline />,
        href: EDocumentsDomainTreeRootIds.alldocumentsDomainTrashbin,
    },
};

export const treeRootAllDocumentsDomainConfig: TreeNodeData[] = [
    documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainDocument],
    documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainSpreadsheet],
    documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainPresentation],
    documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainPdf],
    documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainTrashbin],
];

if (showAllDocumentsIncomingPublic) {
    treeRootAllDocumentsDomainConfig.unshift(documentsDomainTreeItemsFlatten[EDocumentsDomainTreeRootIds.alldocumentsDomainIncoming]);
}
